// Copied from https://github.com/bvaughn/react-virtualized/blob/04d1221133a1c59be24c8af90ae09e46000372b5/source/Table/defaultRowRenderer.js#L1
import React, { Component } from 'react';

import { DragSource, DropTarget } from 'react-dnd';
import { NativeTypes, getEmptyImage } from 'react-dnd-html5-backend';

import flow from 'lodash/flow';

import { notification } from 'antd';

import ContextMenu from '../ContextMenu';

import { ItemTypes } from '../../../../constants/constants';

import api from '../../../../s3-connector/api';

import { getFilesWebkitDataTransferItems, getDirTreeFromFilePaths, getGroupedFilesByFolder } from '../../../../../../shared/utils/files';
import { showRenameSelectedFilesModal } from '../../../../../../shared/utils/files/upload-helper';

class Row extends Component {
  componentDidMount() {
    // This code use for disable drav default ghost image( preview image of draged element).
    // Will deleted when someone finds a solution to perfect drav custom ghost image.
    const { connectDragPreview } = this.props;
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    // This code use for disable drav default ghost image( preview image of draged element).
    // Will deleted when someone finds a solution to perfect drav custom ghost image.
    connectDragPreview(getEmptyImage());
  }

  render() {
    const {
      className,
      columns,
      index,
      onRowClick,
      onRowDoubleClick,
      onRowMouseOut,
      onRowMouseOver,
      onRowRightClick,
      rowData,
      style,
      selection,
      lastSelected,
      loading,
      hasTouch,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      isOver,
      canDrop,
      permissions,
      rowContextMenuItems,
    } = this.props;

    const a11yProps = {};

    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
      a11yProps['aria-label'] = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        // todo: replaced onClick with onMouseDown here and leaving like this for testing purposes
        // onClick is causing issues in DnD feature
        // a11yProps.onClick = event => onRowClick({ event, index, rowData });
        a11yProps.onMouseDown = (event) => {
          if (event.button === 0) {
            // left mouse button
            onRowClick({ event, index, rowData });
          }
        };
      }
      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = (event) => onRowDoubleClick({ event, index, rowData });
      }
      if (onRowMouseOut) {
        a11yProps.onMouseOut = (event) => onRowMouseOut({ event, index, rowData });
      }
      if (onRowMouseOver) {
        a11yProps.onMouseOver = (event) => onRowMouseOver({ event, index, rowData });
      }
      if (onRowRightClick) {
        a11yProps.onContextMenu = (event) => onRowRightClick({ event, index, rowData });
      }
    }

    const isSelected = selection.indexOf(rowData.id) !== -1;

    return connectDragSource(
      connectDropTarget(
        <div
          id={rowData.id}
          onContextMenu={(e) => {
            e.stopPropagation();
          }}
        >
          <ContextMenu rootContainer={() => document.getElementById(rowData.id)} items={rowContextMenuItems} permissions={permissions}>
            <div
              ref={(el) => {
                return connectDragSource(el);
              }}
              {...a11yProps}
              className={`
                    ReactVirtualized__Table__row
                    oc-fm--list-view__row
                    ${!loading && isSelected ? 'oc-fm--list-view__row--selected' : ''}
                    ${isOver && canDrop ? 'oc-fm--list-view__row--drag-over' : ''}
                  `}
              key={rowData.id}
              role="row"
              style={style}
            >
              {columns}
            </div>
          </ContextMenu>
        </div>,
      ),
    );
  }
}

const itemDragSource = {
  beginDrag(props, monitor, component) {
    if (!props.selection || !props.selection.length) {
      return { ids: [props.rowData.id], isSystemFolder: props.rowData.isSystemFolder };
    }

    return { ids: props.selection, isSystemFolder: props.isSystemFolderSelected };
  },

  endDrag(props, monitor, component) {
    if (!monitor.didDrop()) {
      return;
    }

    // When dropped on a compatible target, do something
    const item = monitor.getItem();
    const dropResult = monitor.getDropResult();
  },
};

const itemDropTarget = {
  canDrop(props, monitor) {
    const sourceItem = monitor.getItem();
    const targetItem = props;

    if (sourceItem.ids && sourceItem.ids.findIndex((i) => i === targetItem.rowData.id) >= 0) {
      return false;
    }

    if (
      sourceItem.files &&
      sourceItem.files.some((file) => file.size === 0 && file.type === '') &&
      (targetItem.rowData.id.endsWith('_googledrive') || targetItem.rowData.id.endsWith('_onedrive'))
    ) {
      return false;
    }
    return (
      targetItem.rowData.type === ItemTypes.Directory &&
      !sourceItem.isSystemFolder &&
      (targetItem.permissions ? targetItem.permissions.filePermissions.canAdd : false)
    );
  },

  drop(props, monitor, component) {
    if (monitor.didDrop() || !monitor.canDrop()) {
      return;
    }

    const itemType = monitor.getItemType();

    if (itemType === 'file_or_folder' || itemType === ItemTypes.Directory) {
      const sourceItemIds = monitor.getItem().ids;
      const targetItemId = props.rowData.id;
      const handleMoveItems = props.onMoveItems;

      // internal drag-n-drop
      if (sourceItemIds && sourceItemIds.length && targetItemId) {
        handleMoveItems(sourceItemIds, targetItemId);
      }
    } else if (itemType === NativeTypes.FILE) {
      const targetItemId = props.rowData.id;
      const uploadFiles = props.onUploadDropedFiles;
      const items = monitor.getItem().items;
      const droppedFiles = monitor.getItem().files;
      const isAllMsgFiles = droppedFiles.every((f) => f.name.endsWith('.msg') && f.type === '');
      if (targetItemId.endsWith('_googledrive') || targetItemId.endsWith('_onedrive') || isAllMsgFiles) {
        if (targetItemId && droppedFiles) {
          uploadFiles(targetItemId, droppedFiles, null, null);
        }
      } else {
        getFilesWebkitDataTransferItems(items).then((files) => {
          const paths = files.map((a) => a.filepath);
          const dirTree = getDirTreeFromFilePaths(paths);

          const createFolderTree = (files, targetItemId, dirTree) => {
            api.createFolderTree(targetItemId, dirTree).then((createFolderTreeResut) => {
              const groupedFilesByFolder = getGroupedFilesByFolder(createFolderTreeResut.data, files);
              for (const folderId in groupedFilesByFolder) {
                const filesByFolder = groupedFilesByFolder[folderId].files;
                if (folderId && filesByFolder) {
                  uploadFiles(folderId, filesByFolder, targetItemId, filesByFolder.length);
                }
              }
            });
          };

          const rootfolderNames = _.uniqBy(dirTree.filter((f) => !f.isFile).map((d) => d.name));
          if (rootfolderNames.length) {
            api.getFilesInDestinationFolder(null, rootfolderNames, targetItemId).then((existingFiles) => {
              const existingfileNames = _.uniqBy(existingFiles, 'name').map((x) => x.name);
              if (existingfileNames.length) {
                showRenameSelectedFilesModal(existingfileNames, props.rootContainer, () => {
                  createFolderTree(files, targetItemId, dirTree);
                });
              } else {
                createFolderTree(files, targetItemId, dirTree);
              }
            });
          } else {
            createFolderTree(files, targetItemId, dirTree);
          }
        });
      }
    }

    return { moved: true };
  },
};

export default flow(
  DragSource('file_or_folder', itemDragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  })),
  DropTarget(['file_or_folder', NativeTypes.FILE], itemDropTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  })),
)(Row);
